<ng-container *ngIf="!isLoading() && b; else loading">
  <app-fullscreen-gallery *ngIf="isFullscreenOpen()" [images]="b.images" [activeIndex]="fullscreenIndex()"
    (close)="closeFullscreen()"></app-fullscreen-gallery>

  <app-inquiry-modal *ngIf="isInquiryOpen()" [productId]="b.id" [inquiryType]="inquiryType()"
    [brokerName]="b.contacts[0]?.name || ''" (close)="closeInquiry()"></app-inquiry-modal>

  <section class="product-detail-page">
    <div class="detail-container">
      <button class="back-button" (click)="goBack()" aria-label="Back to Listings">
        ← Back to Listings
      </button>

      <div class="detail-grid" style="display: grid; grid-template-columns: 1fr; gap: 2rem">
        <!-- Desktop Override -->
        <style>
          @media (min-width: 1024px) {
            .detail-grid {
              grid-template-columns: 1.2fr 0.8fr !important;
              gap: 3rem !important;
            }
          }
        </style>

        <!-- Left Column: Image & Broker -->
        <div class="gallery-column">
          <app-image-gallery [images]="b.images" (openFullscreen)="openFullscreen($event)"></app-image-gallery>

          <div class="contacts-locations-wrapper" *ngIf="!isMerchandise()" style="margin-top: 2rem">
            <h3 class="subsection-header" *ngIf="b.contacts.length > 0" style="
                font-size: 1.4rem;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                color: #1e293b;
                border-bottom: 2px solid #f1f5f9;
                padding-bottom: 0.75rem;
                margin-bottom: 1.5rem;
                display: block;
              ">
              Contact Information
            </h3>
            <div class="contacts-grid" *ngIf="b.contacts.length > 0" style="
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                gap: 1.5rem;
                margin-top: 1.5rem;
                justify-content: start;
              ">
              <div class="broker-contact-card" *ngFor="let c of b.contacts" style="
                  background: #f8fafc;
                  border: 1px solid #e2e8f0;
                  padding: 1.5rem;
                  border-radius: 12px;
                  display: flex;
                  flex-direction: column;
                  gap: 1.25rem;
                  transition:
                    transform 0.2s,
                    box-shadow 0.2s;
                ">
                <!-- Top: Identity -->
                <div class="broker-identity" style="display: flex; align-items: center; gap: 1rem">
                  <i class="fas fa-user-circle broker-avatar" style="font-size: 2.5rem; color: #64748b"></i>
                  <div style="display: flex; flex-direction: column; min-width: 0">
                    <span class="broker-name" style="
                        font-weight: 700;
                        color: #1e293b;
                        font-size: 1.15rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      ">{{ c.name }}</span>
                    <span class="broker-title" *ngIf="c.title"
                      style="font-size: 0.85rem; color: #64748b; font-weight: 500">{{ c.title }}</span>
                  </div>
                </div>

                <!-- Bottom: Contact Links -->
                <div class="broker-contact-links" style="
                    display: flex;
                    flex-direction: column;
                    gap: 0.75rem;
                    border-top: 1px solid #f1f5f9;
                    margin-top: 0.25rem;
                    padding-top: 1rem;
                  ">
                  <a [href]="'mailto:' + c.email" class="contact-link" *ngIf="c.email" style="
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 0.95rem;
                      color: #3b82f6;
                      text-decoration: none;
                      font-weight: 600;
                      word-break: break-all;
                    ">
                    <i class="fas fa-envelope" style="width: 16px"></i> {{ c.email }}
                  </a>
                  <a [href]="'tel:' + c.phone" class="contact-link" *ngIf="c.phone" style="
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 0.95rem;
                      color: #3b82f6;
                      text-decoration: none;
                      font-weight: 600;
                    ">
                    <i class="fas fa-phone-alt" style="width: 16px"></i> {{ c.phone }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column: Info & Location -->
        <div class="info-column">
          <header class="detail-header" style="margin-bottom: 1.5rem">
            <div class="detail-subtitle" style="
                color: #64748b;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.05em;
                margin-bottom: 0.5rem;
              ">
              {{ b.boatTypeName }}
            </div>
            <div class="title-rating-row" style="
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 1rem;
              ">
              <h1 class="detail-title" style="
                  font-size: 2.25rem;
                  font-weight: 800;
                  color: #1e293b;
                  margin: 0;
                  line-height: 1.2;
                ">
                {{ b.title }}
              </h1>
              <div class="product-rating" *ngIf="b.averageRating" style="
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                  background: #fef3c7;
                  color: #d97706;
                  padding: 0.4rem 0.8rem;
                  border-radius: 20px;
                  font-weight: 700;
                  flex-shrink: 0;
                ">
                <i class="fas fa-star star"></i>
                <span class="rating-val">{{ b.averageRating | number: '1.1-1' }}</span>
              </div>
            </div>
            <div class="price-row" style="margin-top: 1rem">
              <span class="detail-price" style="font-size: 1.75rem; font-weight: 700; color: #10b981">{{ b.price |
                currency }}</span>
            </div>
          </header>

          <div class="badge-row" style="margin-bottom: 1.5rem">
            <div class="status-badge" [style.background]="
                b.status.toLowerCase().includes('pending')
                  ? 'rgba(212, 175, 55, 0.1)'
                  : 'rgba(16, 185, 129, 0.1)'
              " [style.color]="b.status.toLowerCase().includes('pending') ? '#d4af37' : '#10b981'" style="
                display: inline-block;
                padding: 0.4rem 1rem;
                border-radius: 8px;
                font-weight: 700;
                text-transform: uppercase;
                font-size: 0.8rem;
              ">
              {{ b.status }}
            </div>
          </div>

          <div class="cta-row-main" style="
              display: flex;
              flex-wrap: wrap;
              gap: 1rem;
              align-items: center;
              margin-bottom: 2rem;
            ">
            <button class="action-button primary interest-btn" (click)="openInquiry('INTEREST')" style="
                padding: 1.25rem 2rem;
                font-size: 1.1rem;
                font-weight: 700;
                border-radius: 12px;
                background: #0a192f;
                color: white;
                border: none;
                cursor: pointer;
                transition: all 0.2s;
                white-space: nowrap;
                flex-shrink: 0;
              ">
              I'm Interested
            </button>

            <!-- Social Share Popup -->
            <div class="share-container" style="position: relative">
              <button class="action-button secondary share-trigger-btn"
                (click)="isSharePopupOpen.set(!isSharePopupOpen()); $event.stopPropagation()" style="
                  padding: 1.25rem 2rem;
                  font-size: 1.1rem;
                  font-weight: 700;
                  border-radius: 12px;
                  background: #f1f5f9;
                  color: #1e293b;
                  border: 1px solid #e2e8f0;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                ">
                Share
                <i class="fas" [class.fa-chevron-down]="!isSharePopupOpen()" [class.fa-chevron-up]="isSharePopupOpen()"
                  style="font-size: 0.8rem"></i>
              </button>

              <div class="share-dropdown" [class.share-open]="isSharePopupOpen()" style="
                  position: absolute;
                  top: calc(100% + 10px);
                  right: 0;
                  background: white;
                  border: 1px solid #e2e8f0;
                  border-radius: 12px;
                  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                  z-index: 1000;
                  min-width: 200px;
                  padding: 0.75rem;
                  display: flex;
                  flex-direction: column;
                  gap: 0.25rem;
                  visibility: hidden;
                  opacity: 0;
                  transform: translateY(-10px);
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                ">
                <button (click)="shareTo('facebook')" class="share-item" style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  ">
                  <i class="fab fa-facebook-f" style="color: #1877f2; width: 20px"></i> Facebook
                </button>
                <button (click)="shareTo('instagram')" class="share-item" style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  ">
                  <i class="fab fa-instagram" style="color: #e4405f; width: 20px"></i> Instagram
                </button>
                <button (click)="shareTo('twitter')" class="share-item" style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  ">
                  <!-- Using X logo style -->
                  <i class="fa-brands fa-x-twitter" style="color: #64748b; width: 20px">x</i> X
                </button>
                <button (click)="shareTo('whatsapp')" class="share-item" style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  ">
                  <i class="fab fa-whatsapp" style="color: #25d366; width: 20px"></i> WhatsApp
                </button>
                <div style="height: 1px; background: #f1f5f9; margin: 0.25rem 0"></div>
                <button (click)="shareLink()" class="share-item" style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem;
                    border: none;
                    background: none;
                    width: 100%;
                    border-radius: 8px;
                    cursor: pointer;
                    color: #1e293b;
                    font-weight: 600;
                  ">
                  <i class="fas fa-link" style="color: #64748b; width: 20px"></i> Copy Link
                </button>
                <p *ngIf="shareStatus()" role="status" aria-live="polite" style="font-size: 0.8rem; color: #334155; padding: 0.5rem; max-width: 240px; margin: 0">{{ shareStatus() }}</p>
              </div>
              <style>
                .share-dropdown.share-open {
                  visibility: visible !important;
                  opacity: 1 !important;
                  transform: translateY(0) !important;
                }

                .share-item:hover {
                  background: #f8fafc !important;
                }
              </style>
            </div>
          </div>

          <!-- Description Summary (Intro) -->
          <div class="detail-description-summary" *ngIf="b.description"
            style="margin-bottom: 2rem; border-bottom: 1px solid #f1f5f9; padding-bottom: 2rem">
            <div [innerHTML]="b.description" style="
                color: #4b5563;
                line-height: 1.8;
                font-size: 1.05rem;
                white-space: pre-wrap;
                word-break: break-word;
              "></div>
          </div>

          <!-- Location Grid (Explicitly on Right) -->
          <div class="locations-wrapper" *ngIf="product()?.productTypeId === 1 && b.locations.length > 0">
            <h3 class="subsection-header" style="
                font-size: 1.4rem;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                color: #1e293b;
                border-bottom: 2px solid #f1f5f9;
                padding-bottom: 0.75rem;
                margin-bottom: 1.5rem;
                display: block;
              ">
              Location
            </h3>
            <div class="locations-grid" style="display: flex; flex-direction: column; gap: 0.75rem">
              <a href="javascript:void(0)" (click)="openMap(loc.lat, loc.lng, loc)" class="location-card"
                *ngFor="let loc of b.locations" style="
                  display: flex;
                  align-items: center;
                  padding: 1rem;
                  background: #ffffff;
                  border: 1px solid #e2e8f0;
                  border-radius: 10px;
                  text-decoration: none;
                  color: inherit;
                  transition: all 0.2s;
                ">
                <i class="fas fa-map-marker-alt location-icon"
                  style="color: #ef4444; font-size: 1.25rem; margin-right: 1rem"></i>
                <div class="location-details" style="flex: 1">
                  <span class="location-name" style="display: block; font-weight: 700; color: #1e293b">{{ loc.name
                    }}</span>
                  <span class="location-address" style="display: block; font-size: 0.85rem; color: #64748b">{{
                    loc.addressLine1 }}<br />(click/select for directions)</span>
                  <a [href]="'tel:' + loc?.phone" class="contact-link" *ngIf="loc?.phone" style="
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 0.95rem;
                      color: #3b82f6;
                      text-decoration: none;
                      font-weight: 600;
                    ">
                    <i class="fas fa-phone-alt" style="width: 16px"></i> {{ loc?.phone }}
                  </a>
                </div>
                <i class="fas fa-external-link-alt external-icon" style="color: #94a3b8; font-size: 0.85rem"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs Navigation -->
      <div class="detail-tabs-nav" style="margin-top: 4rem; display: flex; border-bottom: 2px solid #f1f5f9; gap: 3rem">
        <button class="tab-btn" [class.active]="activeTab() === 'details'" (click)="setTab('details')" style="
            background: none;
            border: none;
            padding: 1rem 0.5rem;
            font-size: 1.1rem;
            font-weight: 700;
            cursor: pointer;
            position: relative;
          ">
          Details
          <div *ngIf="activeTab() === 'details'" style="
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 100%;
              height: 3px;
              background: #d4af37;
            "></div>
        </button>
        <button class="tab-btn" [class.active]="activeTab() === 'reviews'" (click)="setTab('reviews')" style="
            background: none;
            border: none;
            padding: 1rem 0.5rem;
            font-size: 1.1rem;
            font-weight: 700;
            cursor: pointer;
            position: relative;
          ">
          Reviews ({{ b.reviewCount }})
          <div *ngIf="activeTab() === 'reviews'" style="
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 100%;
              height: 3px;
              background: #d4af37;
            "></div>
        </button>
      </div>

      <div class="tab-content-wrapper" style="padding-top: 2rem">
        <!-- 0. Specifics - Top Horizontal Row (Requested by Client) -->
        <section class="top-specifics-row" *ngIf="activeTab() === 'details' && !isMerchandise() && b.specs.length > 0"
          style="margin-bottom: 2.5rem; padding-bottom: 2rem; border-bottom: 2px solid #f1f5f9">
          <h2 class="subsection-header" style="
              font-size: 1.4rem;
              font-weight: 800;
              text-transform: uppercase;
              letter-spacing: 0.05em;
              color: #1e293b;
              border-bottom: 2px solid #f1f5f9;
              padding-bottom: 0.75rem;
              margin-bottom: 1.5rem;
              display: block;
            ">
            Specifics
          </h2>
          <div class="horizontal-specs-grid" style="
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
              gap: 1.25rem;
            ">
            <div class="spec-card-slim" *ngFor="let s of b.specs" style="
                background: #f8fafc;
                padding: 1rem 1.25rem;
                border: 1px solid #e2e8f0;
                border-radius: 12px;
                display: flex;
                flex-direction: column;
                gap: 2px;
              ">
              <span class="spec-label" style="
                  font-size: 0.75rem;
                  color: #64748b;
                  text-transform: uppercase;
                  font-weight: 600;
                ">{{ s.label }}</span>
              <span class="spec-value" style="font-size: 1.05rem; font-weight: 700; color: #1e293b">{{ s.value }}</span>
            </div>
          </div>
        </section>
        <style>
          @media (min-width: 1024px) {
            .details-grid-layout {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 3rem;
              align-items: start;
            }

            .details-bottom-grid {
              display: grid;
              grid-template-columns: 2fr 1fr;
              gap: 3rem;
              align-items: start;
              margin-top: 3.5rem;
              /* Reduced to balance spacing */
              padding-top: 2.5rem;
              /* Reduced to balance spacing */
              border-top: 2px solid #f1f5f9;
            }

            /* High-specificity overrides to neutralize global SCSS conflicts */
            /* Using new class names to bypass product-detail global rules */
            .details-tab .layout-details-section,
            .details-tab .propulsion-section,
            .details-tab .features-section,
            .details-tab .layout-specs-section,
            .details-tab section {
              margin-top: 0 !important;
              padding-top: 0 !important;
              border-top: none !important;
              display: flex !important;
              flex-direction: column !important;
              justify-content: flex-start !important;
            }

            .subsection-header {
              margin-top: 0 !important;
              padding-top: 0 !important;
              line-height: 1.2 !important;
              display: block !important;
              border-top: none !important;
              /* Force kill any global top border */
            }

            .two-column-text {
              column-count: 2;
              column-gap: 2rem;
            }

            .full-width-section {
              grid-column: 1 / -1;
            }
          }
        </style>

        <!-- Details Tab Content -->
        <div class="details-tab" *ngIf="activeTab() === 'details'">
          <div class="details-grid-layout" style="margin-top: 0; padding-top: 0">
            <!-- 1. Description (Details Bullets) - Left Side if Yacht, Full if Merch -->
            <section class="layout-details-section" *ngIf="b.safeDetails"
              [style.grid-column]="isMerchandise() ? '1 / -1' : 'span 2'" style="
                margin-top: 0 !important;
                padding-top: 0 !important;
                border-top: none !important;
              ">
              <h2 class="subsection-header" style="
                  font-size: 1.4rem;
                  font-weight: 800;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                  color: #1e293b;
                  border-bottom: 2px solid #f1f5f9;
                  padding-bottom: 0.75rem;
                  margin-bottom: 1.5rem;
                  display: block;
                ">
                Details
              </h2>
              <div class="details-content rich-text-content two-column-text" [innerHTML]="b.safeDetails"
                style="color: #4b5563; font-size: 1.1rem; line-height: 1.6; word-break: break-word"></div>
            </section>

            <!-- 2. (New Placement) Propulsion & Engines - Right Side for Yachts -->
            <section class="propulsion-section" *ngIf="!isMerchandise() && b.propulsions && b.propulsions.length > 0"
              style="
                grid-column: span 1;
                margin-top: 0 !important;
                padding-top: 0 !important;
                border-top: none !important;
              ">
              <h2 class="subsection-header" style="
                  font-size: 1.4rem;
                  font-weight: 800;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                  color: #1e293b;
                  border-bottom: 2px solid #f1f5f9;
                  padding-bottom: 0.75rem;
                  margin-bottom: 1.5rem;
                  display: block;
                ">
                Propulsion & Engines
              </h2>
              <div class="specs-grid-v2" style="display: grid; grid-template-columns: 1fr; gap: 1.25rem">
                <div class="spec-card" *ngFor="let p of b.propulsions; let i = index" style="
                    background: #f8fafc;
                    padding: 1.25rem;
                    border-radius: 12px;
                    border: 1px solid #e2e8f0;
                  ">
                  <span class="spec-label" style="
                      display: block;
                      font-size: 0.8rem;
                      color: #64748b;
                      margin-bottom: 0.4rem;
                      text-transform: uppercase;
                    ">Engine {{ i + 1 }}
                    <ng-container *ngIf="p.engineYear">({{ p.engineYear }})</ng-container></span>
                  <span class="spec-value"
                    style="display: block; font-size: 1.15rem; font-weight: 700; color: #1e293b">{{ p.engineMake }} {{
                    p.engineModel }}</span>
                  <span class="spec-subvalue" *ngIf="p.totalPower"
                    style="display: block; font-size: 0.95rem; color: #475569; margin-top: 6px">Total Power: {{
                    p.totalPower }} HP</span>
                  <span class="spec-subvalue" *ngIf="p.engineType || p.fuelType || p.driveType" style="
                      display: block;
                      font-size: 0.85rem;
                      color: #64748b;
                      margin-top: 6px;
                      border-top: 1px solid #e2e8f0;
                      padding-top: 6px;
                    ">
                    {{ p.engineType
                    }}<ng-container *ngIf="p.engineType && (p.fuelType || p.driveType)">
                      •
                    </ng-container>
                    {{ p.fuelType
                    }}<ng-container *ngIf="(p.fuelType && p.driveType) || (p.engineType && p.driveType)">
                      •
                    </ng-container>
                    {{ p.driveType }}
                  </span>
                </div>
              </div>
            </section>
          </div>

          <div class="details-bottom-grid" style="grid-template-columns: 1fr !important">
            <!-- 3. Features & Equipment - Bottom (Full width now) -->
            <section class="features-section full-width-section" *ngIf="b.features.length > 0" style="
                margin-top: 0 !important;
                padding-top: 0 !important;
                border-top: none !important;
              ">
              <h2 class="subsection-header" style="
                  font-size: 1.4rem;
                  font-weight: 800;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                  color: #1e293b;
                  border-bottom: 2px solid #f1f5f9;
                  padding-bottom: 0.75rem;
                  margin-bottom: 1.5rem;
                  display: block;
                ">
                Features
              </h2>
              <div class="features-grid" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 1.5rem">
                <style>
                  @media (max-width: 1200px) {
                    .features-grid {
                      grid-template-columns: repeat(3, 1fr) !important;
                    }
                  }

                  @media (max-width: 1024px) {
                    .features-grid {
                      grid-template-columns: repeat(2, 1fr) !important;
                    }
                  }

                  @media (max-width: 640px) {
                    .features-grid {
                      grid-template-columns: 1fr !important;
                    }
                  }
                </style>
                <div *ngFor="let group of b.features" class="feature-group" style="break-inside: avoid">
                  <h4 style="
                      color: #d4af37;
                      font-weight: 800;
                      margin-bottom: 0.75rem;
                      text-transform: uppercase;
                      font-size: 0.8rem;
                      letter-spacing: 0.075em;
                      border-left: 3px solid #d4af37;
                      padding-left: 0.75rem;
                    ">
                    {{ group.type }}
                  </h4>
                  <ul class="feature-list" style="
                      list-style: none;
                      padding: 0;
                      display: flex;
                      flex-direction: column;
                      gap: 0.5rem;
                    ">
                    <li *ngFor="let fname of group.features" style="
                        display: flex;
                        align-items: flex-start;
                        gap: 0.6rem;
                        color: #475569;
                        font-size: 0.95rem;
                        line-height: 1.4;
                      ">
                      <i class="fas fa-check" style="color: #10b981; margin-top: 4px; font-size: 0.8rem"></i>
                      {{ fname }}
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>

          <!-- 5. Video Tour (Full Width) -->
          <section class="video-tour-section" *ngIf="b.videoUrl" style="width: 100%; margin-top: 3rem">
            <h2 class="subsection-header" style="
                font-size: 1.4rem;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                color: #1e293b;
                border-bottom: 2px solid #f1f5f9;
                padding-bottom: 0.75rem;
                margin-bottom: 1.5rem;
                display: block;
              ">
              Video Tour
            </h2>
            <div class="video-embed-wrapper" style="
                position: relative;
                padding-bottom: 56.25%;
                height: 0;
                overflow: hidden;
                border-radius: 12px;
                background: #000;
              ">
              <iframe [src]="b.videoUrl | safe"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0" allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                " allowfullscreen>
              </iframe>
            </div>
          </section>
        </div>

        <!-- Reviews Tab Content -->
        <div class="reviews-tab" *ngIf="activeTab() === 'reviews'">
          <app-product-ratings [productId]="b.id" [reviews]="b.reviews"></app-product-ratings>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<ng-template #loading>
  <div class="loading-state">
    <p>Loading details...</p>
  </div>
</ng-template>
